import { FC } from "react";
import { Chip, Stack } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { AgGridGlobalSearch } from "@/components/pages/common/ag-grid/components/global-search/AgGridGlobalSearch";
import { AgGridAllFiltersChip } from "@/components/pages/common/ag-grid/components/filters/AgGridAllFiltersChip";

interface UsersListToolbarProps {
  gridApi: GridApi | null;
  usersCount?: number;
}

export const UsersListToolbar: FC<UsersListToolbarProps> = ({
  gridApi,
  usersCount,
}) => {
  return (
    <Stack
      p={1.5}
      spacing={1.5}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Chip
          size="small"
          variant="filled"
          sx={{
            borderRadius: 1,
            color: "text.secondary",
            fontWeight: "bold",
          }}
          label={`${usersCount} Users`}
        />

        <AgGridAllFiltersChip gridApi={gridApi} />
      </Stack>

      <AgGridGlobalSearch gridApi={gridApi} />
    </Stack>
  );
};
